'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { login } from "../requests/user"

export const useLogin = () => useMutation<API_Success_Response<undefined>, API_Error, string>({
    retry: false,
    mutationFn: login
})